import { Backdrop, CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
// import { Elements } from "@stripe/react-stripe-js";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import paymentImage from "../../assets/Icons//Vector1.svg";
import ShipmentImage from "../../assets/Icons/la_shipping-fast.svg";
import CustomerInfoImage from "../../assets/Icons/Vector.svg";
import { DIRECT_ACCESS_URL } from "../../constants/constants";
import useFetch from "../../customHook/useFetch";
import { setCartCount } from "../../redux/cart";
import {
  fetchCartStoreChanges,
} from "../../common/utils/cartStoreChanges";
import {
  setCheckoutFormSlice,
  setCheckoutOrderSummarySlice,
  setCheckoutSecondFormSlice,
  setCheckoutThirdFormSlice,
} from "../../redux/CheckoutForm/CheckoutFormSlice";
import styles from "../../scss/pageComponent/checkoutCart.module.scss";
import CheckboxGraph from "./CheckboxGraph";
import CheckoutFormDetail from "./CheckoutFormDetail";
import CheckoutShipmentForm from "./CheckoutShipmentForm";
import CheckoutPayment from "./CheckoutPayment";
import CheckoutOrderSummary from "./CheckoutOrderSummary";
import { Decrypt, Encrypt } from "../../common/utils/Functions";
import {
  ensureCartLineIds,
  getPerBundleCustomAnswersForOrder,
  pickCheckoutField,
} from "../../common/utils/cartLineHelpers";
const CheckoutCart = () => {
  const navigate = useNavigate();
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCheckoutFormSlice({}));
    dispatch(setCheckoutSecondFormSlice({}));
    dispatch(setCheckoutOrderSummarySlice({}));
    dispatch(setCheckoutThirdFormSlice({}));
  }, []);

  let data = [
    {
      name: "Customer Information",
      img: CustomerInfoImage,
      competedImg: false,
      done: "false",
      value: 0,
    },
    {
      name: "Shipping Method",
      img: ShipmentImage,
      competedImg: false,
      done: "false",
      value: 1,
    },
    {
      name: "Payment",
      img: paymentImage,
      competedImg: false,
      done: "false",
      value: 2,
    },
  ];

  let summaryDataAll = {
    tax: "",
    tax_type: "",
    is_charge_processing_fee_type: "",
    Processing_fee: "",
    shipping_fee_type: "",
    shipping_amount: "",
    is_offer_rush_shipping: 0,
    rush_shipping_fee: 0,
    store_fees: "",
    payment_handle_type: "",
    hideTax: 1,
  };

  const customerInformation = useSelector(
    (state: any) => state.storeCheckoutForm.FirstFormSlice
  );
  const shippingMethod = useSelector(
    (state: any) => state.storeCheckoutForm.SecondFormSlice
  );
  // const paymentData = useSelector(
  //   (state: any) => state.storeCheckoutForm.ThirdFormSlice
  // );
  const orderSummary = useSelector(
    (state: any) => state.storeCheckoutForm.OrderSummary
  );
  // const stripePromise = loadStripe(process.env.REACT_APP_PUBLISH_KEY || "");

  const cartDataInfoD = localStorage?.getItem("cart");
  const cartDataInfo = Decrypt(cartDataInfoD);
  const cartOldData = cartDataInfo ? JSON.parse(cartDataInfo) : [];

  const cartHasBundle = cartOldData.some((item: any) => !item.isSingleProduct);
  /** Any bundle in cart → customer step is email/phone only (attached singles still use bundle player info). */
  const bundleOnlyCustomerStep = cartHasBundle;

  const formDataInSlice = useSelector((state: any) => state.storeCheckoutForm);
  const [selected, setSelected] = useState<any>(0);
  const [imageData, setImageData] = useState(data);

  const [idOfStore, setIDofStore] = useState("");
  const [storeDetail, setStoreDetail] = useState(null);
  const [orgId, setOrgId] = useState(0);
  const [summaryData, setSummaryData] = useState(summaryDataAll);

  const [isCollectTax, setIsCollectTax] = useState(false);
  const [cartChangesPending, setCartChangesPending] = useState(true);

  const blockForCartChanges = () => {
    if (!cartChangesPending) return false;
    toast.error(
      "Accept the item changes or remove the item before continuing."
    );
    return true;
  };

  const ClickTab = (e: any) => {
    // useSelected(e);
    if (Number(e) > Number(selected) && blockForCartChanges()) return;

    if (e === 1) {
      if (formDataInSlice?.FirstFormSlice?.email) {
        setSelected(1);
      }
    } else if (e === 2) {
      if (ShowSpecificForm.ShippingForm === false) {
        if (formDataInSlice?.FirstFormSlice?.email) {
          setSelected(2);
        }
      } else if (formDataInSlice?.SecondFormSlice.firstName) {
        setSelected(2);
      }
    } else {
      setSelected(0);
    }
    // setSummaryData()
  };
  let ClickTabFromButton = (e: any) => {
    if (blockForCartChanges()) return;
    setSelected(e);
    if (e == 1) {
      imageData[0].competedImg = true;
      setImageData(imageData);
    } else if (e == 2) {
      imageData[0].competedImg = true;

      if (imageData.length > 2) {
        imageData[1].competedImg = true;
      }
      setImageData(imageData);
    } else if (e == 3) {
      imageData[0].competedImg = true;
      imageData[1].competedImg = true;
      imageData[2].competedImg = true;
    }
  };

  let formInfo = {
    customerForm: true,
    PaymentForm: true,
    ShippingForm: true,
  };

  const [showFullname, setshowFullname] = useState(true);
  const [collectBillingInfo, setCollectBillingInfo] = useState(true);
  const [paymentType, setPaymentType] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [grandTotalCopy, setGrandTotalCopy] = useState(0);

  const [custom_informations, setCustom_informations] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [ShowSpecificForm, setShowSpecificForm] = useState(formInfo);

  // const [wholeData, setWholeData] = useState();
  const [first, setfirst] = useState();

  const [InfoData, { response: getResponse, error }] = useFetch(
    `/get-store-info/${DIRECT_ACCESS_URL}`,
    {
      method: "get",
    }
  );

  const [
    orderCreate,
    {
      response: responseOrderCreate,
      loading: orderCreateLoading,
      error: orderCreateError,
    },
  ] = useFetch("/order-create", {
    method: "post",
  });

  // const [
  //   sendErrorEmail,
  //   {
  //     response: responseSendErrorEmail,
  //     loading: sendErrorEmailLoading,
  //     error: sendErrorEmailError,
  //   },
  // ] = useFetch("/send-error-email", {
  //   method: "post",
  // });

  const placeOrder = async (
    fistStep: any = null,
    secondStep: any = null,
    paymentData: any = null,
    custom_info: any = null
  ) => {
    setIsLoading(true);
    const normalizeNullableId = (value: any) =>
      value === "" || value === null || value === undefined ? null : value;

    const cartDataInfoD = localStorage?.getItem("cart");
    const cartDataInfo = cartDataInfoD ? Decrypt(cartDataInfoD) : null;
    const cartForOrder = cartDataInfo ? JSON.parse(cartDataInfo) : [];
    ensureCartLineIds(cartForOrder);

    if (idOfStore) {
      try {
        const pendingChanges = await fetchCartStoreChanges(
          idOfStore,
          cartForOrder
        );
        if (pendingChanges.length > 0) {
          setIsLoading(false);
          toast.error(
            "A cart item changed in the store. Accept the changes or remove the item before placing the order."
          );
          setTimeout(() => window.location.reload(), 2000);
          return;
        }
      } catch (error) {
        console.log(error);
      }
    }

    const firstBundleCheckoutInfo = cartForOrder.find(
      (item: any) => !item.isSingleProduct && item.bundle_checkout_info
    )?.bundle_checkout_info;

    // No-bundle: answers from checkout form (unscoped).
    // Bundle cart: one answer set per bundle_group_key (cartLineId), matching products.
    let custom_question_answer: any = [];
    const formCustomAnswers =
      Array.isArray(custom_info) && custom_info.length > 0
        ? custom_info
        : Array.isArray(customerInformation?.customeSave) &&
          customerInformation.customeSave.length > 0
        ? customerInformation.customeSave
        : null;
    if (formCustomAnswers) {
      formCustomAnswers.forEach((data: any) => {
        custom_question_answer.push({
          question_id: data.id,
          answer: data.value != null ? data.value.toString() : "",
        });
      });
    } else {
      custom_question_answer = getPerBundleCustomAnswersForOrder(cartForOrder);
    }

    const productList: any = [];
    cartForOrder.map((val: any) => {
      if (val.isSingleProduct) {
        const productOption: any = [];
        val.store_options.map((option: any) => {
          const optionName = option.store_option_items.find(
            (optionData: any) => {
              if (optionData.id === option.selectedData) {
                return optionData.option_name.toString();
              }
            }
          );

          productOption.push({
            option_id: option.id,
            option_type: option.option_type,
            option_value:
              option.input_type === 1
                ? optionName
                  ? optionName.option_name.toString()
                  : ""
                : option.selectedData.toString(),
            option_name: option ? option?.display_name.toString() : "-",
          });
        });
        let bundleIdForLine = 0;
        let linePlayerInfo: any = null;
        let bundleGroupKey: string | null = null;
        if (val.parentBundleLineId != null) {
          const parentRow = cartForOrder.find(
            (r: any) =>
              !r.isSingleProduct &&
              Number(r.cartLineId) === Number(val.parentBundleLineId)
          );
          if (parentRow) {
            bundleIdForLine = parentRow.id;
            linePlayerInfo = parentRow.bundle_checkout_info;
            bundleGroupKey = String(val.parentBundleLineId);
          }
        }
        productList.push({
          bundle_id: bundleIdForLine,
          ...(bundleGroupKey ? { bundle_group_key: bundleGroupKey } : {}),
          store_product_id: val.id,
          quantity: val.quantity ? val.quantity : 1,
          base_price: val.base_price ? val.base_price : 0,
          club_price: val.club_price ? val.club_price : 0,
          product_options: productOption,
          player_first_name: linePlayerInfo?.firstName ?? "",
          player_last_name: linePlayerInfo?.lastName ?? "",
          team_id: normalizeNullableId(linePlayerInfo?.teamId),
          jersey_number: linePlayerInfo?.jerseyNumber ?? "",
          grad_year: linePlayerInfo?.grad_year ?? "",
          last_name: linePlayerInfo?.last_name ?? "",
          misc: linePlayerInfo?.misc ?? "",
        });
      } else {
        val.bundle_products.map((product: any) => {
          const productOption: any = [];
          if (
            product.store_product_detail.store_options &&
            product.store_product_detail.store_options.length > 0
          ) {
            product.store_product_detail.store_options.map((option: any) => {
              const optionName = option.store_option_items.find(
                (optionData: any) => {
                  if (optionData.id === option.selectedData) {
                    return optionData.option_name.toString();
                  }
                }
              );

              productOption.push({
                option_id: option.id,
                option_value:
                  option.input_type === 1
                    ? optionName
                      ? optionName.option_name.toString()
                      : ""
                    : option.selectedData.toString(),
                option_type: option.option_type,
                option_name: option ? option?.display_name.toString() : "-",
              });
            });
          }
          const bInfo = val.bundle_checkout_info;
          const bundleGroupKey = String(val.cartLineId);
          productList.push({
            bundle_id: product.bundle_id,
            bundle_group_key: bundleGroupKey,
            store_product_id: product.store_product_detail.id,
            quantity: product.store_product_detail.quantity
              ? product.store_product_detail.quantity
              : 0,
            base_price: product.store_product_detail.base_price
              ? product.store_product_detail.base_price
              : 0,
            club_price: product.store_product_detail.club_price
              ? product.store_product_detail.club_price
              : 0,
            product_options: productOption,
            player_first_name: bInfo?.firstName ?? "",
            player_last_name: bInfo?.lastName ?? "",
            team_id: normalizeNullableId(bInfo?.teamId),
            jersey_number: bInfo?.jerseyNumber ?? "",
            grad_year: bInfo?.grad_year ?? "",
            last_name: bInfo?.last_name ?? "",
            misc: bInfo?.misc ?? "",
          });
        });
      }
    });
    let check_billing_address = paymentData
      ? paymentData.checkbox
        ? 1
        : 0
      : 1;



    if (!orderSummary.coupon_id) {
      if (
        paymentData &&
        paymentData.token !== "" &&
        Number(orderSummary.total_amount) < 0.5
      ) {
        toast.dismiss();
        toast.error("Order Total should be equal or greater than $0.50");
        setIsLoading(false);
        return false;
      }
    }

    const shippingFirstName = pickCheckoutField(
      secondStep?.firstName,
      shippingMethod?.firstName
    );

    const request = {
      token: paymentData && paymentData.token !== "" ? paymentData.token : "",
      org_id: orderSummary.org_id ? orderSummary.org_id : 1,
      store_id: idOfStore,
      coupon_id: orderSummary.coupon_id ? orderSummary.coupon_id : "",
      coupon_code: orderSummary.coupon_code ? orderSummary.coupon_code : "",
      coupon_amount: orderSummary.coupon_amount
        ? orderSummary.coupon_amount
        : "0.00",
      total_amount: orderSummary.total_amount ? orderSummary.total_amount : 0,
      company_bear_amount: orderSummary.company_bear_amount ? orderSummary.company_bear_amount : '0.00',
      used_coupon_amount: orderSummary?.used_coupon_amount ? `${orderSummary?.used_coupon_amount}` : "0.00",
      sub_total: orderSummary.sub_total ? orderSummary.sub_total : 0,
      sale_tax: orderSummary.sale_tax ? orderSummary.sale_tax : 0,
      is_offer_rush_shipping: orderSummary.is_offer_rush_shipping
        ? orderSummary.is_offer_rush_shipping
        : 0,
      processing_fee: orderSummary.processing_fee
        ? Number(orderSummary.sub_total) === 0
          ? 0
          : orderSummary.processing_fee
        : "",
      ship_to_home: orderSummary.ship_to_home ? orderSummary.ship_to_home : "",
      payment_type: "",
      status: 1,
      player_first_name: pickCheckoutField(
        fistStep?.firstName,
        customerInformation?.firstName,
        firstBundleCheckoutInfo?.firstName
      ),
      team_id: pickCheckoutField(
        fistStep?.teamId,
        customerInformation?.teamId,
        firstBundleCheckoutInfo?.teamId
      ),
      jersey_number: pickCheckoutField(
        fistStep?.jerseyNumber,
        customerInformation?.jerseyNumber,
        firstBundleCheckoutInfo?.jerseyNumber
      ),
      grad_year: pickCheckoutField(
        fistStep?.grad_year,
        customerInformation?.grad_year,
        firstBundleCheckoutInfo?.grad_year
      ),
      last_name: pickCheckoutField(
        fistStep?.last_name,
        customerInformation?.last_name,
        firstBundleCheckoutInfo?.last_name
      ),
      misc: pickCheckoutField(
        fistStep?.misc,
        customerInformation?.misc,
        firstBundleCheckoutInfo?.misc
      ),
      player_last_name: pickCheckoutField(
        fistStep?.lastName,
        customerInformation?.lastName,
        firstBundleCheckoutInfo?.lastName
      ),
      email: pickCheckoutField(fistStep?.email, customerInformation?.email),
      phone_number: pickCheckoutField(
        fistStep?.phone,
        customerInformation?.phone
      ),
      s_first_name: shippingFirstName,
      s_last_name: pickCheckoutField(
        secondStep?.lastName,
        shippingMethod?.lastName
      ),
      s_street: pickCheckoutField(secondStep?.street, shippingMethod?.street),
      s_apt: pickCheckoutField(secondStep?.aptUnit, shippingMethod?.aptUnit),
      s_country: shippingFirstName ? "USA" : "",
      s_city: pickCheckoutField(secondStep?.city, shippingMethod?.city),
      s_state: pickCheckoutField(
        secondStep?.state != null ? String(secondStep.state) : "",
        shippingMethod?.state != null ? String(shippingMethod.state) : ""
      ),
      s_zip: pickCheckoutField(secondStep?.zipCode, shippingMethod?.zipCode),
      // is_billing_address: 1,
      is_billing_address: check_billing_address,
      b_first_name:
        check_billing_address === 0 && paymentData && paymentData.firstName
          ? paymentData.firstName
          : "",
      b_last_name:
        check_billing_address === 0 && paymentData && paymentData.lastName
          ? paymentData.lastName
          : "",
      b_street:
        check_billing_address === 0 && paymentData && paymentData.street
          ? paymentData.street
          : "",
      b_apt:
        check_billing_address === 0 && paymentData && paymentData.aptUnit
          ? paymentData.aptUnit
          : "",
      b_country: "USA",
      b_city:
        check_billing_address === 0 && paymentData && paymentData.city
          ? paymentData.city
          : "",
      b_state:
        check_billing_address === 0 && paymentData && paymentData.state
          ? paymentData.state.toString()
          : "",
      b_zip:
        check_billing_address === 0 && paymentData && paymentData.zipCode
          ? paymentData.zipCode
          : "",
      payment_status: "",
      custom_question_answer: custom_question_answer,
      order_products: productList,
    };

    orderCreate(request);
  };

  useEffect(() => {
  
    if (responseOrderCreate?.status && responseOrderCreate?.status === 1) {
      const orderResponce = {
        id: responseOrderCreate.data.id,
        orderId: responseOrderCreate.data.customer_order_id,
        email: responseOrderCreate.data.customer_email,
        receipt: responseOrderCreate.data.receipt,
        storeName: responseOrderCreate.data.store_name,
      };

      localStorage.removeItem("cart");
      dispatch(setCartCount(0));
      dispatch(setCheckoutFormSlice({}));
      setIsLoading(false);
      navigate("/thankyou", { state: { orderResponce } });
    } else {
      toast.error(orderCreateError?.message);
      if (orderCreateError?.status && orderCreateError?.status === 2) {
        localStorage.removeItem("cart");
        dispatch(setCartCount(0));
        dispatch(setCheckoutFormSlice({}));
        navigate("/");
        setIsLoading(false);
        return;
      }
      if (orderCreateError?.code?.toString() === "404") {
        localStorage.removeItem("cart");
        navigate("/");
      }
      setIsLoading(false);
    }
  }, [responseOrderCreate, orderCreateError]);

  // useEffect(() => {
  //   if(orderCreateError){
  //     sendErrorEmail({
  //       data: orderCreateError,
  //     });
  //   }
  // }, [orderCreateError]);
  useLayoutEffect(() => {
    InfoData();
  }, []);

  useLayoutEffect(() => {
    if (getResponse?.data) {
      setStoreDetail(getResponse?.data ?? null);
      setIDofStore(getResponse?.data?.id);
      setOrgId(getResponse?.data?.org_id ?? 0);
      setshowFullname(getResponse?.data?.is_name_collected);
      setCollectBillingInfo(getResponse?.data?.is_collect_billing_info);
      setPaymentType(getResponse?.data?.payment_handle_type);
      setCustom_informations(getResponse?.data?.custom_informations);
      // let objOfData: any = [
      //   { payment_handle_type: getResponse?.data?.payment_handle_type },
      //   { shipping_method_type: getResponse?.data?.shipping_method_type },
      // ];

      summaryDataAll = {
        tax:
          summaryData?.tax !== "" ? summaryData?.tax : getResponse?.data?.tax,
        tax_type: getResponse?.data?.tax_type,
        is_charge_processing_fee_type:
          getResponse?.data?.is_charge_processing_fee,
        Processing_fee: "",
        shipping_fee_type: getResponse?.data?.shipping_method_type,
        shipping_amount: getResponse?.data?.shipping_method_value,
        is_offer_rush_shipping: getResponse?.data?.is_offer_rush_shipping,
        rush_shipping_fee: getResponse?.data?.rush_shipping_fee,
        store_fees: getResponse?.data?.store_fees,
        payment_handle_type: getResponse?.data?.payment_handle_type,
        hideTax: getResponse?.data?.where_to_ship,
      };

      setSummaryData(summaryDataAll);
      setfirst(getResponse?.data);
      const cartDataInfoD = localStorage?.getItem("cart");
      const cartDataInfo = Decrypt(cartDataInfoD);
      const cartData = cartDataInfo ? JSON.parse(cartDataInfo) : [];
      const isSingleProduct = cartData?.find(
        (item: any) => item?.isSingleProduct
      );
      if (
        (getResponse?.data?.payment_handle_type === 2 &&
          getResponse?.data?.is_collect_billing_info === 0) ||
        (getResponse?.data?.payment_handle_type === 3 &&
          getResponse?.data?.is_collect_billing_info === 0 &&
          isSingleProduct === undefined &&
          grandTotal === 0) ||
        (grandTotal === 0 && getResponse?.data?.payment_handle_type !== 2)
      ) {
        data = data.filter(function (item) {
          return item.value !== 2;
        });
        setImageData([...data]);
        formInfo.PaymentForm = false;
        setShowSpecificForm(formInfo);
      } else {
        setImageData([...data]);
        formInfo.PaymentForm = true;
        setShowSpecificForm(formInfo);
      }

      if (
        getResponse?.data?.shipping_method_type === 0 &&
        (((getResponse?.data?.where_to_ship === 1 || getResponse?.data?.where_to_ship === 2) &&
          getResponse?.data?.tax_type !== 1) ||
          getResponse?.data?.where_to_ship === 0)
      ) {
        data = data.filter(function (item) {
          return item.value !== 1;
        });
        setImageData([...data]);
        formInfo.ShippingForm = false;
        setShowSpecificForm(formInfo);
      }

      setIsCollectTax(
        ((getResponse?.data?.where_to_ship === 1 || getResponse?.data?.where_to_ship === 2) &&
          getResponse?.data?.tax_type === 1 &&
          (isSingleProduct !== undefined ||
            getResponse?.data?.payment_handle_type === 1)) ||
          formInfo?.PaymentForm === false
          ? true
          : false
      );
    }
  }, [getResponse, grandTotal]);

  useEffect(() => {
    const cartDataInfoD = localStorage?.getItem("cart");
    const cartDataInfo = Decrypt(cartDataInfoD);
    const cartData = cartDataInfo ? JSON.parse(cartDataInfo) : [];

    if (cartData.length <= 0) {
      navigate("/");
      return;
    }

    ensureCartLineIds(cartData);
    localStorage.setItem("cart", Encrypt(JSON.stringify(cartData)));

    const hasBundle = cartData.some((item: any) => item && !item.isSingleProduct);
    const hasLooseStandalone = cartData.some(
      (item: any) =>
        item?.isSingleProduct &&
        (item.parentBundleLineId == null || item.parentBundleLineId === "")
    );
    if (hasBundle && hasLooseStandalone) {
      navigate("/cart");
    }
  }, [navigate]);
  useEffect(() => {

    if (selected === 2) {
      if (grandTotal === 0) {
        if (ShowSpecificForm?.ShippingForm) {
          setSelected(1);
        } else {
          setSelected(0);
        }
      }
    }
  }, [grandTotal]);
  console.log(JSON.stringify(orderSummary), "orderSummary");

  return (
    <>
      <div>
        <Box sx={{ flexGrow: 1 }}>
          <CheckboxGraph
            data={imageData}
            selected={setSelected}
            click={ClickTab}
            formSelect={selected}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              <p className={styles.flowName}>{data[selected].name}</p>
              {selected === 0 && (
                <CheckoutFormDetail
                  storeDetail={storeDetail}
                  showFullname={showFullname}
                  custom_informations={custom_informations}
                  selected={ClickTabFromButton}
                  formInfo={formInfo}
                  first={first}
                  isLoading={isLoading}
                  ShowSpecificForm={ShowSpecificForm}
                  bundleOnlyCustomerStep={bundleOnlyCustomerStep}
                  placeOrder={placeOrder}
                  cartChangesPending={cartChangesPending}
                />
              )}
              {selected === 1 && (
                <CheckoutShipmentForm
                  selected={ClickTabFromButton}
                  formInfo={formInfo}
                  ShowSpecificForm={ShowSpecificForm}
                  isLoading={isLoading}
                  placeOrder={placeOrder}
                  setSummaryData={setSummaryData}
                  summaryData={summaryData}
                  isCollectTax={isCollectTax}
                  cartChangesPending={cartChangesPending}
                />
              )}
              {selected === 2 && (
                // <Elements stripe={stripePromise}>
                <CheckoutPayment
                  idOfStore={idOfStore}
                  ShowSpecificForm={ShowSpecificForm}
                  collectBillingInfo={collectBillingInfo}
                  paymentType={paymentType}
                  placeOrder={placeOrder}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  grandTotal={grandTotal}
                  cartChangesPending={cartChangesPending}
                />
                // </Elements>
              )}
            </Grid>
            <Grid item xs={12} md={5}>
              <CheckoutOrderSummary
                idOfStore={idOfStore}
                orgId={orgId}
                summaryData={summaryData}
                data={imageData}
                selected={selected}
                grandTotal={grandTotal}
                grandTotalCopy={grandTotalCopy}
                setGrandTotal={setGrandTotal}
                setGrandTotalCopy={setGrandTotalCopy}
                onPendingStoreChanges={setCartChangesPending}
              />
            </Grid>
          </Grid>
        </Box>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={orderCreateLoading}
      >
        <CircularProgress
          color="primary"
          size={60}
          className={styles.loaderColor}
        />
      </Backdrop>
    </>
  );
};

export default CheckoutCart;
